export default "__VITE_ASSET__cbe0aeab__"